module.exports = __webpack_public_path__ + "static/media/target.b0adaeb7.png";